import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
  // debug: true,
  interpolation: {
    // React already does escaping
    escapeValue: false,
  },
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  // Using simple hardcoded resources for simple example
  resources: {
    'en-GB': {
      translation: {
        'Short & leveraged ETP guide': 'Short & leveraged ETP guide',
        'Ask anything': 'Ask anything',
        'Enter your question about Short and Leveraged products':
          'Enter your question about Short and Leveraged products',
        ToolDescription:
          'The tool provides a quick and convenient way to find answers to frequently asked questions about Short and Leveraged Exchange-Traded Products (S&L ETPs)',
        helpText: 'If your question is not answered, please refer to our<1> contact us</1> page.',
      },
    },
    'it-IT': {
      translation: {
        'Short & leveraged ETP guide': 'Guida ETP breve e a leva',
        'Ask anything': 'Chiedi qualsiasi cosa',
        'Enter your question about Short and Leveraged products':
          'Inserisci la tua domanda sui Short e Leveraged product',
        ToolDescription:
          'Il tool fornisce un modo rapido e conveniente per trovare le risposte alle domande più frequenti su Short e Leveraged Exchange-Traded Product (S&L ETP).',
        helpText: 'Se la tua domanda non ha risposta, fai riferimento alla nostra <1>pagina di contatto</1>.',
      },
    },
    'de-DE': {
      translation: {
        'Short & leveraged ETP guide': 'Short & Leveraged ETF-Leitfaden',
        'Ask anything': 'Frag irgendwas',
        'Enter your question about Short and Leveraged products':
          'Geben Sie Ihre Frage zu Short- und Leveraged-Produkten ein.',
        ToolDescription:
          'Das Tool bietet schnell und bequem Antworten auf häufig gestellte Fragen zu Short und Leveraged Exchange Traded Products (S&L ETPs).',
        helpText: 'Falls Sie nicht die Antwort auf Ihre Frage finden, besuchen Sie bitte <1>unsere Kontaktseite</1>.',
      },
    },
  },
});

export default i18next;
